import { Theme, ThemeMode } from '@/types';

export const LIGHT_THEME: Theme = {
  id: 'light',
  name: 'Light',
  colors: {
    background: '#ECEAEA',
    foreground: '#121212',
    primary: '#1e8067',
    'primary-foreground': '#ffffff',
    secondary: '#f4d821',
    'secondary-foreground': '#000000',
    accent: '#c1093133',
    'accent-foreground': '#c10931',
    destructive: '#c10931',
    'destructive-foreground': '#ffffff',
    muted: '#e4e4e7',
    'muted-foreground': '#71717a',
    border: '#1e8067',
    input: '#ffffff',
    ring: '#1e8067',
    card: '#ffffff',
    'card-foreground': '#121212',
    popover: '#ffffff',
    'popover-foreground': '#121212',
    'sidebar-bg': '#ffffff',
    'sidebar-text': '#1e8067',
    'accent-color': '#1e8067',
    'main-bg': '#ECEAEA',
    'btn-gradient': 'linear-gradient(270deg, #f4d821 0%, #e2c512 100%)',
    'table-head': 'linear-gradient(89deg, #1e8067, #1e8067 89.28%)',
    'login-gradient': 'linear-gradient(89deg, #1e8067, #1e8067 89.28%)',
    'header-gradient': 'linear-gradient(89deg, #1e8067, #1e8067 89.28%)',
  },
};

export const DARK_THEME: Theme = {
  id: 'dark',
  name: 'Dark',
  colors: {
    background: '#09090b',
    foreground: '#fafafa',
    primary: '#1e8067',
    'primary-foreground': '#ffffff',
    secondary: '#f4d821',
    'secondary-foreground': '#000000',
    accent: '#c1093133',
    'accent-foreground': '#fafafa',
    destructive: '#ef4444',
    'destructive-foreground': '#ffffff',
    muted: '#27272a',
    'muted-foreground': '#a1a1aa',
    border: '#27272a',
    input: '#09090b',
    ring: '#1e8067',
    card: '#09090b',
    'card-foreground': '#fafafa',
    popover: '#09090b',
    'popover-foreground': '#fafafa',
    'sidebar-bg': '#121212',
    'sidebar-text': '#fafafa',
    'accent-color': '#1e8067',
    'main-bg': '#09090b',
    'btn-gradient': 'linear-gradient(270deg, #f4d821 0%, #e2c512 100%)',
    'table-head': 'linear-gradient(89deg, #1e8067, #1e8067 89.28%)',
    'login-gradient': 'linear-gradient(89deg, #1e8067, #1e8067 89.28%)',
    'header-gradient': 'linear-gradient(89deg, #1e8067, #1e8067 89.28%)',
  },
};

export const THEMES: Theme[] = [
  LIGHT_THEME,
  DARK_THEME,
  {
    id: 'premium-casino',
    name: 'Premium Casino',
    colors: {
      background: '#151515',
      foreground: '#ffffff',

      primary: '#c8102e',
      'primary-foreground': '#ffffff',

      secondary: '#242424',
      'secondary-foreground': '#ffffff',

      accent: '#c8102e',
      'accent-foreground': '#111111',

      destructive: '#ff3b30',
      'destructive-foreground': '#ffffff',

      muted: '#ffffff',
      'muted-foreground': '#b8b8b8',

      border: '#4a1f29',

      input: '#ffffff',

      ring: '#c8102e',

      card: '#04539C',
      'card-foreground': '#ffffff',

      popover: '#202020',
      'popover-foreground': '#ffffff',

      // Sidebar
      'sidebar-bg': '#3d0612',
      'sidebar-text': '#ffffff',

      // Main background
      'main-bg': '#151515',
      'accent-color': '#8b0524',
      // Buttons
      'btn-gradient':
        'linear-gradient(to right, rgb(135, 15, 41) 0%, rgb(214, 4, 49) 50%, rgb(0, 0, 0) 100%)',
      // Table header
      'table-head': 'linear-gradient(90deg,#8e0e25 0%,#c8102e 100%)',

      // Login modal
      'login-gradient': 'linear-gradient(135deg,#005bea 0%,#2b8cff 100%)',

      // Header
      'header-gradient': 'linear-gradient(94.28deg, #04539c 30%, #d60431 70%)',
    },
  },

  {
    id: 'corporate',
    name: 'Corporate Blue',
    colors: {
      background: '#eef6ff',
      foreground: '#001b33',
      primary: '#007fff',
      'primary-foreground': '#ffffff',
      secondary: '#dbeafe',
      'secondary-foreground': '#007fff',
      accent: '#bfdbfe',
      'accent-foreground': '#007fff',
      destructive: '#ef4444',
      'destructive-foreground': '#ffffff',
      muted: '#f0f7ff',
      'muted-foreground': '#4b5563',
      border: '#bfdbfe',
      input: '#ffffff',
      ring: '#007fff',
      card: '#ffffff',
      'card-foreground': '#001b33',
      popover: '#ffffff',
      'popover-foreground': '#001b33',
      'sidebar-bg': '#ffffff',
      'sidebar-text': '#007fff',
      'accent-color': '#007fff',
      'main-bg': '#eef6ff',
      'btn-gradient': 'linear-gradient(270deg, #007fff 0%, #dbeafe 100%)',
      'table-head': 'linear-gradient(270deg, #007fff 0%, #0059b2 100%)',
      'login-gradient': 'linear-gradient(270deg, #007fff 0%, #bfdbfe 100%)',
      'header-gradient': 'linear-gradient(270deg, #007fff 0%, #bfdbfe 100%)',
    },
  },
  {
    id: 'playful',
    name: 'Playful Purple',
    colors: {
      background: '#fff0f5',
      foreground: '#330033',
      primary: '#9b30ff',
      'primary-foreground': '#ffffff',
      secondary: '#fcd0f3',
      'secondary-foreground': '#9b30ff',
      accent: '#f3b2e7',
      'accent-foreground': '#9b30ff',
      destructive: '#ef4444',
      'destructive-foreground': '#ffffff',
      muted: '#fff5fb',
      'muted-foreground': '#4b5563',
      border: '#f3b2e7',
      input: '#ffffff',
      ring: '#9b30ff',
      card: '#ffffff',
      'card-foreground': '#330033',
      popover: '#ffffff',
      'popover-foreground': '#330033',
      'sidebar-bg': '#ffffff',
      'sidebar-text': '#9b30ff',
      'accent-color': '#9b30ff',
      'main-bg': '#fff0f5',
      'btn-gradient': 'linear-gradient(270deg, #9b30ff 0%, #fcd0f3 100%)',
      'table-head': 'linear-gradient(270deg, #9b30ff 0%, #ef4444 100%)',
      'login-gradient': 'linear-gradient(270deg, #9b30ff 0%, #f3b2e7 100%)',
      'header-gradient': 'linear-gradient(270deg, #9b30ff 0%, #f3b2e7 100%)',
    },
  },
];

export const DEFAULT_THEME_MODE: ThemeMode = 'system';
export const DEFAULT_THEME: Theme = THEMES[2] as Theme;

export const THEME_STORAGE_KEY = 'admin-template-theme';
export const THEME_MODE_STORAGE_KEY = 'admin-template-theme-mode';

export function getSystemTheme(): 'light' | 'dark' {
  if (typeof window === 'undefined') return 'light';
  return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
}

export function applyTheme(theme: Theme, mode: ThemeMode) {
  const root = document.documentElement;
  const isDarkMode = mode === 'dark' || (mode === 'system' && getSystemTheme() === 'dark');

  // Remove all theme classes
  root.className = root.className.replace(/theme-\w+/g, '');

  // Add dark class if needed
  root.classList.toggle('dark', isDarkMode);

  // Add theme class if not default light/dark theme
  if (theme.id !== 'light' && theme.id !== 'dark') {
    root.classList.add(`theme-${theme.id}`);
  }

  // Apply CSS variables
  Object.entries(theme.colors).forEach(([key, value]) => {
    root.style.setProperty(`--${key}`, value);
  });
}

export function saveThemePreference(theme: Theme, mode: ThemeMode) {
  if (typeof window === 'undefined') return;

  localStorage.setItem(THEME_STORAGE_KEY, theme.id);
  localStorage.setItem(THEME_MODE_STORAGE_KEY, mode);
}

export function getStoredThemePreference(): { theme: Theme; mode: ThemeMode } {
  if (typeof window === 'undefined') {
    return { theme: DEFAULT_THEME, mode: DEFAULT_THEME_MODE };
  }

  const storedThemeId = localStorage.getItem(THEME_STORAGE_KEY);
  const storedMode = localStorage.getItem(THEME_MODE_STORAGE_KEY);

  let theme = DEFAULT_THEME;
  if (storedThemeId) {
    const foundTheme = THEMES.find((t) => t.id === storedThemeId);
    if (foundTheme) {
      theme = foundTheme;
    }
  }
  const mode =
    storedMode && ['light', 'dark', 'system'].includes(storedMode)
      ? (storedMode as ThemeMode)
      : DEFAULT_THEME_MODE;

  return { theme, mode };
}
